module.exports = __webpack_public_path__ + "media/r_monsueur.85b7fd5b.mp3";